import { dispatch } from "@rematch/core";
import { getOrderTag } from "utils/interface";
import { CQ } from "utils/commonQuest";

// 订单标签
export const orderTag = {
  state: {},
  effects: {
    // 获取订单标签数据
    async getOrderTag(payload: any, rootState: any) {
      // 等待异步调用的结果
      //const data = await _GET(APIS.getPrimaryCategories);
      const data = await CQ(getOrderTag());
      dispatch["share"].updateOrdreTag(data);
    }
  }
};
